import React from 'react';
import SingleColumnTemplate from '@templates/SingleColumn';
import Date from '@components/Date';
import styles from './HonorsAndAwards.module.scss';
import RawHTML from '@components/RawHTML';

export default function HonorsAndAwards({
  h1 = 'Honors & Awards',
  title = 'Honors and Awards',
  items: _items,
  intro: _intro,
  data,
  ...restProps
}) {
  const intro = _intro ?? <RawHTML>{data?.markdownRemark?.html}</RawHTML>;
  const items = _items ?? data?.markdownRemark?.frontmatter?.content ?? [];

  return (
    <SingleColumnTemplate
      title={title}
      h1={h1}
      {...restProps}
    >
      {intro}
      <ul className={styles.list}>
        {items?.map((item, index) => (
          <Item
            key={index}
            {...item}
          />
        ))}
      </ul>
    </SingleColumnTemplate>
  );
}

function Item({ text_md: text, date, subtext_md: subtext }) {
  return !text ? null : (
    <li>
      <div className={styles.text}>
        <span className={styles.title}>
          <RawHTML>{text}</RawHTML>
        </span>
        {date && (
          <div className={styles.dateWrapper}>
            <Date
              value={date}
              className={styles.date}
            />
          </div>
        )}
      </div>
      {subtext && (
        <div className={styles.subtext}>
          <RawHTML>{subtext}</RawHTML>
        </div>
      )}
    </li>
  );
}
